import React from "react";

const StudentReservationPolicy = () => {
  const reservationData = [
    { category: "Scheduled Caste", percentage: "15%" },
    { category: "Scheduled Tribes", percentage: "7.5%" },
    { category: "Other Backward Class", percentage: "27%" },
    { category: "Economically Weaker Section", percentage: "10%" },
    { category: "Person with Disability", percentage: "4%" },
  ];

  const totalPercentage = reservationData.reduce((total, item) => {
    return total + parseFloat(item.percentage);
  }, 0);

  return (
    <div className="gdlr-core-pbf-sidebar-wrapper" style={{ margin: "30px 0" }}>
      <div className="gdlr-core-pbf-sidebar-container gdlr-core-line-height-0 clearfix gdlr-core-js gdlr-core-container">
        
        {/* Title Section */}
        <div className="gdlr-core-pbf-element">
          <div className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr" 
               style={{ paddingBottom: 0, textAlign: "center" }}>
            <div className="gdlr-core-title-item-title-wrap clearfix text-center">
              <h3 className="gdlr-core-title-item-title gdlr-core-skin-title" 
                  style={{ fontSize: "30px", fontWeight: 600, color: "#000" }}>
                 STUDENT ADMISSION RESERVATION POLICY - UGC
              </h3>
             
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="gdlr-core-pbf-element" style={{ margin: "20px 0" }}>
          <div className="gdlr-core-divider-item gdlr-core-divider-item-normal gdlr-core-item-pdlr gdlr-core-center-align">
            <div className="gdlr-core-divider-line gdlr-core-skin-divider" 
                 style={{ borderColor: "#7c1c1b", borderBottomWidth: "2px", width: "80%" }}></div>
          </div>
        </div>

        {/* Main Content Area */}
        <div className="gdlr-core-pbf-sidebar-content gdlr-core-column-60 gdlr-core-pbf-sidebar-padding gdlr-core-line-height gdlr-core-column-extend-left" 
             style={{ padding: "20px 0px 30px 0px" }}>
          <div className="gdlr-core-pbf-sidebar-content-inner">
            
            {/* Introductory Note */}
            <div className="gdlr-core-pbf-element" style={{ marginBottom: "25px" }}>
              <div className="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align">
                <div className="gdlr-core-text-box-item-content" style={{ fontSize: "16px", lineHeight: "1.6" }}>
                  <p style={{ margin: 0 }}>
                    As per the Government of India and UGC guidelines, Immaculate Institute of Health Sciences, 
                    Karaikal follows the following reservation policy for student admissions across all courses:
                  </p>
                </div>
              </div>
            </div>

            {/* Policy Table */}
            <div className="gdlr-core-pbf-element">
              <div className="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align">
                <div className="reservation-table-container" 
                     style={{ overflowX: "auto", margin: "20px 0", border: "1px solid #e0e0e0", borderRadius: "5px" }}>
                  <table className="reservation-policy-table" 
                         style={{ width: "100%", borderCollapse: "collapse", fontSize: "16px" }}>
                    <thead>
                      <tr style={{ backgroundColor: "#7c1c1b", color: "#fff" }}>
                        <th style={{ padding: "18px", textAlign: "center", fontWeight: 600, fontSize: "17px" }}>S.NO</th>
                        <th style={{ padding: "18px", textAlign: "left", fontWeight: 600, fontSize: "17px" }}>CATEGORY</th>
                        <th style={{ padding: "18px", textAlign: "center", fontWeight: 600, fontSize: "17px" }}>RESERVATION %</th>
                      </tr>
                    </thead>
                    <tbody>
                      {reservationData.map((item, index) => (
                        <tr key={index} 
                            style={{ 
                              backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#fff",
                              borderBottom: "1px solid #e0e0e0",
                              transition: "background-color 0.3s ease"
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f0f7ff"}
                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = index % 2 === 0 ? "#f9f9f9" : "#fff"}>
                          <td style={{ padding: "16px", textAlign: "center", fontWeight: 500, fontSize: "16px" }}>{index + 1}</td>
                          <td style={{ padding: "16px", textAlign: "left", fontWeight: 500, fontSize: "16px" }}>
                            <div style={{ display: "flex", alignItems: "center" }}>
                              <span style={{ 
                                display: "inline-block", 
                                width: "12px", 
                                height: "12px", 
                                backgroundColor: getCategoryColor(index), 
                                borderRadius: "50%", 
                                marginRight: "12px" 
                              }}></span>
                              {item.category}
                            </div>
                          </td>
                          <td style={{ 
                            padding: "16px", 
                            textAlign: "center", 
                            fontWeight: 600, 
                            color: "#7c1c1b",
                            fontSize: "17px"
                          }}>
                            {item.percentage}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                      <tr style={{ backgroundColor: "#fff8e1", borderTop: "2px solid #7c1c1b" }}>
                        <td colSpan="2" style={{ padding: "18px", textAlign: "right", fontWeight: 600, fontSize: "17px" }}>
                          Total Reserved Seats:
                        </td>
                        <td style={{ 
                          padding: "18px", 
                          textAlign: "center", 
                          fontWeight: 700, 
                          color: "#7c1c1b",
                          fontSize: "18px"
                        }}>
                          {totalPercentage}%
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>

            {/* General Category Note */}
          

          </div>
        </div>

        {/* Right Sidebar - Important Information */}
        

      </div>
    </div>
  );
};

// Helper function for category colors
const getCategoryColor = (index) => {
  const colors = ["#FF6B6B", "#4ECDC4", "#45B7D1", "#96CEB4", "#FFEAA7"];
  return colors[index % colors.length];
};

export default StudentReservationPolicy;